import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue27 } from '../../../../Fct/generics';
import { FaChartLine } from 'react-icons/fa';
import { getAaveV3Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var GetReserveNormalizedVariableDebt = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getReserveNormalizedVariableDebt',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }), isPreview: true, icon: FaChartLine }),
                },
            },
            output: {
                normalizedVariableDebt: new FctValue27({ innerIndex: 0, isPreview: true }),
            },
        });
    },
});
